import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as DocumentalIcn } from '../../../../icons/documentale-icon.svg';
import getColorClasses from '../../lib/getColorClasses';

const Documentale = ({ currentPath }) => {
  const { t } = useTranslation('PAGES');
  const validPaths = ['/app/documentale'];

  return (
    <ListItem>
      <Link to="/app/documentale" className="flex">
        <DocumentalIcn className={getColorClasses(currentPath, validPaths)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('LIBRARY')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default Documentale;
